import {Component, HostBinding} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {EntityForm} from '@catuimodels/shared/entity-form';

const componentBaseName = 'not-implemented-yet';
const selectorName = 'cat-' + componentBaseName;

const defaultClassNames = [selectorName].join(' ');

@Component({
  selector: 'cat-not-implemented-yet',
  templateUrl: './not-implemented-yet.component.html',
})
export class NotImplementedYetComponent extends EntityForm {
  @HostBinding('class') classNames = defaultClassNames;

  constructor(formBuilder: FormBuilder) {
    super(formBuilder);
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/ui-models/components/not-implemented-yet/not-implemented-yet.component.ts